import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { SiteModel, SiteStepperModel } from 'src/app/models/index';
import {
  CommonService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import { SiteStepperEnum } from 'src/app/shared';
import { AlertService, Constants } from 'src/app/shared/index';
declare var $: any;

export interface SourcesDetails {
  siteId: string;
  make: string;
  altSources: any;
  dieselGenerators: any;
  dgEnergyMeter: string;
  newSolarSource: any;
}
export class SourceModel {
  constructor(
    public name?: string,
    public make?: string,
    public capacity?: boolean,
    public maxOperatingPoint?: string,
    public fuelPrice?: string,
    public fuelRatekwh?: string,
    public meterId?: string,
    public insiteMeterID?: string,
    public hasFlowMeter?: string
  ) {}
}
export class SolarModel {
  constructor(
    public nNme?: string,
    public FlowChannelID?: string,
    public Location?: string
  ) {}
}
@Component({
  selector: 'app-reserves-and-sources',
  templateUrl: './reserves-and-sources.component.html',
  styleUrls: ['./reserves-and-sources.component.scss']
})
export class ReservesAndSourcesComponent implements OnInit, AfterViewInit {
  formdata: UntypedFormGroup;
  formDG: UntypedFormGroup;
  formAlternate: UntypedFormGroup;
  formPvModule: UntypedFormGroup;
  siteId: string;
  altSourcesDetails: any;
  startView = 'month';
  minView = 'day';
  addNewDG = false;
  showErrorForNewDG = false;
  form = {
    commissionedDate: new Date().toDateString(),
    lastServicedDate: new Date().toDateString(),
    dgCommissionedDate: moment(new Date()).format(
      Constants.MOMENT_DATE_FORMAT.DATE_FORMAT
    ),
    dgLastServicedDate: moment(new Date()).format(
      Constants.MOMENT_DATE_FORMAT.DATE_FORMAT
    ),
    flowMeter: 'no',
    dgEnergyMeterObj: undefined,
    sensorsinputNo: '',
    stringinputNo: '',
    pvModulesinputNo: '',
    inverterinputNo: ''
  };
  UPSDetails = {
    submitted: false
  };
  altSources = [
    { type: 'Wind', text: 'Wind' },
    { type: 'CHP', text: 'CHP' },
    { type: 'EnergyExchange', text: 'Energy Exchange' }
  ];
  altSourcesForStringsAndModules: any;
  solarAltSourcesList = [];
  ChooseFlowMeterRole = [
    { FmeterRole: 'Fuel' },
    { FmeterRole: 'Water' },
    { FmeterRole: 'Air' },
    { FmeterRole: 'Gas' },
    { FmeterRole: 'Sewage' },
    { FmeterRole: 'BTU' },
    { FmeterRole: 'Co2' },
    { FmeterRole: 'O2' }
  ];
  siteAndAreaLevel = ['Site Level', 'Area Level'];
  orientation = [
    'North',
    'South',
    'East',
    'West',
    'North-East',
    'North-West',
    'South-East',
    'South-West'
  ];
  moduleType = ['Amorphous', 'Poly-Crystalline'];
  areaLevel = ['Site Level', 'Area Wise'];
  TemperatureSensor = 'no';
  batteryTypes: any;
  soCMeasurementTypes: any;
  bankConnectionTypes: any;
  siteModel: SiteModel;
  unAssignedDGMeters: any;
  unAssignedSolarMeters: any;

  siteIdReadOnly: boolean;
  addNewSolar: boolean;
  slrHasIrdSensor: boolean;
  showErrorForNewSolar: boolean;
  slrHasEngMtr: boolean;
  flowMeterCheck = true;
  logoAttachment: any;
  layoutAttachment: any;
  otherAttachments: any;
  StringNameList: any;
  InverterMakeList: any;
  solarAreasOfThisSite: any;
  processesList: any;
  solarlayoutAttachment = {
    name: ''
  };
  emailList = [];
  displayedColumns = [
    'name',
    'make',
    'capacity',
    'maxOperatingPoint',
    'fuelPrice',
    'fuelRatekwh',
    'meterId',
    'insiteMeterID',
    'hasFlowMeter'
  ];
  displayedColumnsSolar = ['Name', 'FlowChannelID', 'Location'];
  dgSources: MatTableDataSource<SourceModel>;
  solarIrradianceList: MatTableDataSource<SolarModel>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) solarPaginator: MatPaginator;
  max = new Date();
  constructor(
    private fb: UntypedFormBuilder,
    private siteStepperService: SiteStepperService,
    private siteService: SiteService,
    private commonService: CommonService,
    private alertService: AlertService
  ) {
    this.altSourcesDetails = {
      siteId: '',
      make: '',
      altSources: [],
      dieselGenerators: [],
      dgEnergyMeter: '',
      newSolarSource: {},
      hasTempSensor: false,
      bankConnection: {
        rId: '',
        text: '',
        value: ''
      },
      batteryType: {
        rId: '',
        text: '',
        value: ''
      },
      soCMeasurementType: { rId: '', text: '', value: '' },
      siteAndAreaLevel: '',
      solarAreaWiseSummary: false,
      solarAreaNames: {},
      installedCapacity: ''
    };

    this.altSourcesForStringsAndModules = {
      siteId: this.siteId,
      altsiteAndAreaLevel: '',
      altsolarAreaNames: {
        name: ''
      },
      invertersMake: '',
      stringName: '',
      altstringDetails: [],
      altmoduleDetails: []
    };
  }

  ngOnInit() {
    const t = this;
    t.formdata = t.fb.group({
      makeCtr: ['', [this.startWhitespace]],
      inverterCapacityCtr: [],
      backupTimeCtr: [''],
      noOfBatteriesCtr: ['', [Validators.pattern('[0-9]*')]],
      batteryMakeCtr: ['', [this.startWhitespace]],
      batteryTypeCtr: [''],
      batteryRatingCtr: ['', [Validators.pattern('[0-9.]*')]],
      dischargingCurrentCtr: ['', [Validators.pattern('[0-9.]*')]],
      soCMeasurementTypeCtr: [],
      chargeTimeCtr: [],
      chargingCurrentCtr: ['', [Validators.pattern('[0-9.]*')]],
      impedanceCtr: ['', [Validators.pattern('[0-9.]*')]],
      bankConnectionTypesCtr: [],
      commissionedDateCtr: [],
      serviceIntervalCtr: [],
      lastServicedDateCtr: [],
      dodCtr: [],
      bankCapacityCtr: []
    });

    t.formDG = t.fb.group({
      // DG
      dgNameCtr: ['', [this.startWhitespace]],
      dgMakeCtr: ['', [this.startWhitespace]],
      dgCapacityCtr: [],
      maxOperatingPointCtr: [
        '',
        [Validators.maxLength(3), Validators.pattern('[0-9]*')]
      ],
      fuelPriceCtr: [],
      fuelRateCtr: ['', [Validators.pattern('[0-9.]*')]],
      dGCommissionedDatePicker: [],
      dgLastServicedDatePicker: [],
      dgEnergyMeterObjCtr: [],
      flowMeterRoleCtr: [],
      flowMeterMakeCtr: [],
      flowMeterSerialNoCtr: [],
      flowMeterInsiteMeterIDCtr: [],
      flowMeterMeterIDCtr: []
    });

    t.formAlternate = t.fb.group({
      alttypeCtr: [],
      altmakeCtr: [],
      altratedCapacityCtr: [],
      expectedSolarDailyOutputCtr: [],
      siteLevelNumericIdCtr: [],
      pVModuleCtr: [],
      moduleNoCtr: [],
      moduleWpCtr: [],
      inverterTypeCtr: [],
      temperatureSensorLevelCtr: [],
      flowChannelNameCtr: [],
      flowChannelIDCtr: [],
      ioChannnelSerialNumberCtr: [],
      irradianceSensorLevelCtr: [],
      newflowChannelNameCtr: [],
      newflowChannelIDCtr: [],
      newioChannnelSerialNumberCtr: [],
      emailRecepientToListCtr: [],
      emailRecepientCcListCtr: [],
      emailRecepientBccListCtr: [],
      siteAndAreaLevelCtr: [],
      solarAreaNamesCtr: [],
      installedCapacityCtr: [],
      orientationCtr: [],
      tiltCtr: [],
      solarAreaWiseSummaryCtr: [],
      solarProcessesCtr: [],
      sensorsinputNoCtr: [],
      altflowChannelNameCtr: [],
      altflowChannelIDCtr: [],
      altIoChannnelSerialNumberCtr: [],
      inverterinputNoCtr: [],
      invertermakeCtr: [],
      inverterratingCtr: [],
      varInverterTypeCtr: [],
      noOfInvertersCtr: []
    });

    t.formPvModule = t.fb.group({
      altsiteAndAreaLevelCtr: [],
      altsolarAreaNamesCtr: [],
      invertersMakeCtr: [],
      stringinputNoCtr: [],
      pvstringNameCtr: [],
      pvModulesinputNoCtr: [],
      stringnameCtr: [],
      capacityCtr: [],
      pvModuleMakeCtr: [],
      moduleTypeCtr: [],
      moduleWpCtr: [],
      noOfModulesCtr: []
    });
    this.siteModel = new SiteModel();
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.ReservesAndSources &&
        !this.commonService.isNullOrUndefined(data.siteModel)
      ) {
        this.siteId = data.siteModel.siteId;
        this.altSourcesDetails.siteId = this.siteId;
        this.altSourcesForStringsAndModules.siteId = this.siteId;
        this.siteModel = data.siteModel;
        this.initData();
        window.addEventListener('keydown', function (event) {
          if (event.keyCode === 13) {
            const element: any = event.srcElement;
            if (element.id === 'strings') {
              t.generateStringsForm(t.form.stringinputNo);
            }
            if (element.id === 'pvModules') {
              t.generatepvModulesForm(t.form.pvModulesinputNo);
            }
            event.preventDefault();
            return false;
          }
        });
      }
    });
  }
  public startWhitespace(control: UntypedFormControl) {
    if (
      (control.value as string) &&
      (control.value as string).indexOf(' ') == 0
    ) {
      return { whitespace: true };
    }
    return null;
  }
  ngAfterViewInit() {}
  initData() {
    const t = this;
    t.siteService.getOptionsByClassName('BattType').subscribe((data) => {
      this.batteryTypes = data;
    });
    t.siteService.getOptionsByClassName('SoCMeaType').subscribe((data) => {
      t.soCMeasurementTypes = data;
    });
    t.siteService
      .getOptionsByClassName('BankConnectionType')
      .subscribe((data) => {
        t.bankConnectionTypes = data;
      });

    t.siteService.getUserEmailsBySiteId(t.siteId).subscribe((emailList) => {
      t.emailList = emailList;
    });
    t.siteService.getSolarAreasOfSite(t.siteId).subscribe((data) => {
      t.solarAreasOfThisSite = data;
    });
    t.siteService.getSolarProcessesBySiteId(t.siteId).subscribe((processes) => {
      t.processesList = processes;
    });
    this.getUnassignedMetersOfRole('DG');
    this.loadAltSourcesDetails();
  }
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formdata.get(fieldName).hasError(errorCode);
  };
  public isFieldHasErrors = (fieldName: string, errorCode: string): boolean => {
    return this.formDG.get(fieldName).hasError(errorCode);
  };
  loadAltSourcesDetails() {
    this.siteService.getAltSourcesDetails(this.siteId).subscribe((data) => {
      if (!this.commonService.isNullOrUndefined(data)) {
        this.validateAltSourceDetails(data);
        this.altSourcesDetails = data;
        this.form.commissionedDate = moment(
          this.altSourcesDetails.commissionedDate
        ).format(Constants.MOMENT_DATE_FORMAT.DATE_FORMAT);
        this.form.lastServicedDate = moment(
          this.altSourcesDetails.lastServicedDate
        ).format(Constants.MOMENT_DATE_FORMAT.DATE_FORMAT);

        const altSourcesTmp = [];
        const solarSourcesTmp = [];
        const dgSourcesTmp = [];

        for (let i = 0; i < this.altSources.length; i++) {
          let found = false;
          if (this.altSourcesDetails.altSources !== undefined) {
            for (let j = 0; j < this.altSourcesDetails.altSources.length; j++) {
              if (
                this.altSources[i].type ===
                this.altSourcesDetails.altSources[j].type
              ) {
                found = true;
                altSourcesTmp.push(this.altSourcesDetails.altSources[j]);
                break;
              }
            }
          }
          if (found === false) {
            altSourcesTmp.push(undefined);
          }
        }

        // Add solar also from data
        if (this.altSourcesDetails.altSources !== undefined) {
          for (let i = 0; i < this.altSourcesDetails.altSources.length; i++) {
            if (this.altSourcesDetails.altSources[i].type === 'Solar') {
              solarSourcesTmp.push(this.altSourcesDetails.altSources[i]);
            }
          }
        }
        this.solarAltSourcesList = solarSourcesTmp;
        this.altSourcesDetails.altSources = altSourcesTmp;
        this.altSourcesDetails.newSolarSource = {
          connectedIrradiationSensor: {}
        };

        if (this.altSourcesDetails.dieselGenerators !== undefined) {
          for (
            let k = 0;
            k < this.altSourcesDetails.dieselGenerators.length;
            k++
          ) {
            dgSourcesTmp.push(this.altSourcesDetails.dieselGenerators[k]);
          }
        }
        this.altSourcesDetails.flowMeterRole =
          this.ChooseFlowMeterRole[0].FmeterRole;

        this.dgSources = new MatTableDataSource<SourceModel>(dgSourcesTmp);
        this.dgSources.paginator = this.paginator;

        // const solarIrradiance = [{ "FlowChannelID": "1", "Location": "SiteLevel", "Name": "JaP_Irradiance" }];
        // this.solarIrradianceList = new MatTableDataSource<SolarModel>(solarIrradiance);
        // this.solarIrradianceList.paginator = this.solarPaginator;

        if (this.altSourcesDetails.siteLevelNumericId !== '') {
          this.siteIdReadOnly = true;
        } else {
          this.siteIdReadOnly = false;
        }
        if (this.altSourcesDetails.newSolarTemp === null) {
          this.altSourcesDetails.newSolarTemp = {
            temperatureSensorLevel: '',
            ioChannnelSerialNumber: undefined,
            name: undefined,
            flowChannelID: undefined
          };

          this.altSourcesDetails.solarAreaNames = {};
        }
        if (this.altSourcesDetails.bankConnection == null) {
          this.altSourcesDetails.bankConnection = {
            rId: '',
            text: '',
            value: ''
          };
        }
      }
    });
  }
  validateAltSourceDetails(data) {
    if (this.commonService.isNullOrUndefined(data.batteryType)) {
      data.batteryType = { rId: '', text: '', value: '' };
      // data.batteryType = {};
    }
    if (this.commonService.isNullOrUndefined(data.soCMeasurementType)) {
      data.soCMeasurementType = { rId: '', text: '', value: '' };
      // data.soCMeasurementType = {};
    }
    if (this.commonService.isNullOrUndefined(data.bankConnection)) {
      data.bankConnection = { rId: '', text: '', value: '' };
      // data.bankConnection = {};
    }
    if (this.commonService.isNullOrUndefined(data.altSources)) {
      data.altSources = [];
    }
    if (this.commonService.isNullOrUndefined(data.dieselGenerators)) {
      data.dieselGenerators = [];
    }
    if (this.commonService.isNullOrUndefined(data.newSolarSource)) {
      data.newSolarSource = {};
    }
  }
  showAddNewDGForm() {
    if (!this.addNewDG) {
      this.altSourcesDetails.dgName = '';
      this.altSourcesDetails.dgEnergyMeter = '';
      this.altSourcesDetails.dgMake = '';
      this.altSourcesDetails.dgCapacity = '';
      this.altSourcesDetails.fuelPrice = '';
      this.altSourcesDetails.flowMeterID = '';
      this.altSourcesDetails.flowMeterInsiteID = '';
      this.altSourcesDetails.flowMeterSerialNo = '';
      this.altSourcesDetails.flowMeterMake = '';
      this.altSourcesDetails.hasFlowMeter = false;
      this.addNewDG = true;
      this.showErrorForNewDG = false;
    }
  }

  clearAddNewDGForm() {
    this.addNewDG = false;
    this.showErrorForNewDG = false;
    this.clearNewDGFormDetails();
  }

  clearNewDGFormDetails() {
    // Clear DG details
    this.altSourcesDetails.dgName = undefined;
    this.altSourcesDetails.dgMake = undefined;
    this.altSourcesDetails.dgCapacity = undefined;
    this.altSourcesDetails.maxOperatingPoint = undefined;
    this.altSourcesDetails.fuelPrice = undefined;
    this.altSourcesDetails.fuelRate = undefined;
    this.form.dgCommissionedDate = undefined;
    this.form.dgLastServicedDate = undefined;
    this.altSourcesDetails.hasFlowMeter = false;
    this.altSourcesDetails.dgEnergyMeter = undefined;
    this.altSourcesDetails.flowMeterID = undefined;
    this.altSourcesDetails.flowMeterInsiteID = undefined;
    this.altSourcesDetails.flowMeterSerialNo = undefined;
    this.altSourcesDetails.flowMeterMake = undefined;
    this.altSourcesDetails.flowMeterRole = undefined;
    this.form.flowMeter = 'no';
    this.form.dgEnergyMeterObj = undefined;
  }

  clearAddNewAltSource(sourcename) {
    if (sourcename === 'Solar') {
      this.addNewSolar = false;
      this.altSourcesDetails.newSolarSource.name = undefined;
      this.altSourcesDetails.newSolarSource.make = undefined;
      this.altSourcesDetails.newSolarSource.ratedCapacity = undefined;
      this.slrHasIrdSensor = false;
      this.altSourcesDetails.newSolarSource.hasIrradiationSensor = false;
      this.altSourcesDetails.newSolarSource.connectedIrradiationSensor = {};
      this.altSourcesDetails.newSolarSource.connectedIrradiationSensor.make =
        undefined;
      this.altSourcesDetails.newSolarSource.connectedIrradiationSensor.id =
        undefined;
      this.showErrorForNewSolar = false;
      this.slrHasEngMtr = false;
      this.altSourcesDetails.newSolarSource.hasEnergyMeter = false;
    }
  }

  setFlowMeter(value) {
    this.form.flowMeter = value;
    if (value === 'yes') {
      this.flowMeterCheck = false;
    }
    this.altSourcesDetails.hasFlowMeter = value === 'yes';

    if (value === 'no') {
      this.altSourcesDetails.flowMeterID = undefined;
      this.altSourcesDetails.flowMeterInsiteID = undefined;
      this.altSourcesDetails.flowMeterSerialNo = undefined;
      this.altSourcesDetails.flowMeterMake = undefined;
      this.altSourcesDetails.flowMeterRole = undefined;
    }
  }

  setTemperatureSensor(value) {
    this.TemperatureSensor = value;
    this.altSourcesDetails.hasTempSensor = value === 'yes';
    if (value === 'no') {
      if (this.altSourcesDetails.newSolarTemp !== undefined) {
        this.altSourcesDetails.newSolarTemp.ioChannnelSerialNumber = undefined;
        this.altSourcesDetails.newSolarTemp.name = undefined;
        this.altSourcesDetails.newSolarTemp.flowChannelID = undefined;
      }
    }
  }

  updateTabularData() {
    const t = this;
    t.siteService.getAltSourcesDetails(t.siteId).subscribe((data) => {
      t.altSourcesDetails.dieselGenerators =
        this.commonService.isNullOrUndefined(data.dieselGenerators)
          ? []
          : data.dieselGenerators;
      t.dgSources = data.dieselGenerators;
      const solarSourcesTmp = [];
      for (let i = 0; i < data.altSources.length; i++) {
        if (data.altSources[i].type === 'Solar') {
          solarSourcesTmp.push(data.altSources[i]);
        }
      }
      t.solarAltSourcesList = solarSourcesTmp;
      if (!this.commonService.isNullOrUndefined(data.attachments)) {
        for (let i = 0; i < data.attachments.length; i++) {
          if (
            data.attachments[i].documentType ===
            Constants.DOCUMENT_TYPE.SOLAR_LAYOUT
          ) {
            t.solarlayoutAttachment = data.attachments[i];
          }
        }
      }
    });
    t.getUnassignedMetersOfRole('DG');
    t.getUnassignedMetersOfRole('Solar');
    t.clearNewDGFormDetails();
    t.clearAddNewAltSource('Solar');

    t.siteService.getConnectedIrradiationSensor(t.siteId).subscribe((data) => {
      t.solarIrradianceList = data;
    });
  }

  submitAlternateSourcesDetails() {
    const t = this;
    // if (t.validNewDGDetails() && t.validNewSolarDetails()) {
    try {
      t.altSourcesDetails.commissionedDate = new Date(
        t.form.commissionedDate
      ).getTime();
      t.altSourcesDetails.lastServicedDate = new Date(
        t.form.lastServicedDate
      ).getTime();
      t.altSourcesDetails.dgCommissionedDate = new Date(
        t.form.dgCommissionedDate
      ).getTime();
      t.altSourcesDetails.dgLastServicedDate = new Date(
        t.form.dgLastServicedDate
      ).getTime();
    } catch (e) {}
    const altSourcesDetails = Object.assign({}, t.altSourcesDetails);
    altSourcesDetails.dgEnergyMeter =
      t.form.dgEnergyMeterObj !== undefined
        ? t.form.dgEnergyMeterObj.meterId
        : null;

    const altSourcesTmp = [];
    if (altSourcesDetails.altSources !== undefined) {
      for (let i = 0; i < altSourcesDetails.altSources.length; i++) {
        if (altSourcesDetails.altSources[i] !== undefined) {
          altSourcesTmp.push(altSourcesDetails.altSources[i]);
        }
      }
    }
    altSourcesDetails.altSources = altSourcesTmp;
    t.UPSDetails.submitted = true;
    t.altSourcesDetails.attachments = [];
    t.altSourcesDetails.attachments.push(t.solarlayoutAttachment);

    t.siteService
      .saveAltSourcesDetails(this.siteId, altSourcesDetails)
      .subscribe((data) => {
        if (data !== null && data.rId !== '') {
          t.alertService.showSuccess(Constants.MESSAGE.Save_success);
          // Update available DG's and Solars in Accordion
          t.updateTabularData();
          t.showErrorForNewDG = false;
          t.showErrorForNewSolar = false;
        } else {
          t.alertService.showError(Constants.MESSAGE.Save_failure);
        }
        t.UPSDetails.submitted = false;
      });
    // }
  }

  getUnassignedMetersOfRole(meterRoleName) {
    this.siteService
      .getUnassignedMetersOfRole(this.siteId, meterRoleName, 'NA')
      .subscribe((data) => {
        if (meterRoleName === 'Solar') {
          this.unAssignedSolarMeters = data;
        }
        if (meterRoleName === 'DG') {
          this.unAssignedDGMeters = data;
        }
      });
  }
  public selectDocument = (elmId: string) => {
    const element: HTMLElement = document.getElementById(elmId);
    element!.click();
  };
  public uploadDocument = (event: any, pictType: string) => {
    const t = this;
    if (event.target.files.length <= 0) {
      return;
    }
    const files = event.target.files;
    if (!this.commonService.isImageFile(files[0])) {
      this.commonService.showDialogMessage('File type not supported!');
      return;
    }
    const formData = new FormData();
    formData.append('file', files[0]);
    formData.append('documentType', pictType);

    t.siteService
      .uploadDocument(formData, pictType, 'comment', this.siteId)
      .subscribe(
        (data) => {
          if (
            this.commonService.isNullOrUndefined(data) ||
            data.fileContent === ''
          ) {
            t.alertService.showError('Upload file fail!');
            return;
          }
          const index = data.index;

          if (data.documentType === Constants.DOCUMENT_TYPE.LOGO) {
            t.logoAttachment = data;
          } else if (data.documentType === Constants.DOCUMENT_TYPE.LAYOUT) {
            t.layoutAttachment = data;
          } else if (data.documentType === Constants.DOCUMENT_TYPE.OTHER) {
            t.otherAttachments[index] = data;
          } else if (
            data.documentType === Constants.DOCUMENT_TYPE.SOLAR_LAYOUT
          ) {
            t.solarlayoutAttachment = data;
          }
          // console.log(t.loadImgFileContents);
        },
        (data) => {
          t.alertService.showError(
            'Upload file fail! Only upload maximum 2MB per file.'
          );
        }
      );
  };
  setIRSensor(value) {
    this.slrHasIrdSensor = value === 'yes';
    if (value === 'no') {
      this.altSourcesDetails.newSolarSource.connectedIrradiationSensor = {};
      this.altSourcesDetails.newSolarSource.connectedIrradiationSensor.make =
        undefined;
      this.altSourcesDetails.newSolarSource.connectedIrradiationSensor.id =
        undefined;
    }
  }

  setEngMtr(value) {
    this.slrHasEngMtr = value === 'yes';
    if (value === 'no') {
      this.altSourcesDetails.newSolarSource.hasEnergyMeter = false;
    }
  }

  validNewDGDetails() {
    if (
      $('#dgName').hasClass('ng-invalid') ||
      $('#dgEnergyMeter').hasClass('ng-invalid') ||
      $('#dgMake').hasClass('ng-invalid') ||
      $('#dgCapacity').hasClass('ng-invalid') ||
      (this.altSourcesDetails.hasFlowMeter &&
        ($('#flowMeterID').hasClass('ng-invalid') ||
          $('#flowMeterInsiteID').hasClass('ng-invalid') ||
          $('#flowMeterSerialNo').hasClass('ng-invalid') ||
          $('#flowMeterMake').hasClass('ng-invalid')))
    ) {
      this.showErrorForNewDG = true;
      return false;
    } else {
      return true;
    }
  }

  validNewSolarDetails() {
    if (
      $('#slrExpectedOutput').hasClass('ng-invalid') ||
      $('#slrFlowChannel').hasClass('ng-invalid') ||
      $('#sensorLevel').hasClass('ng-invalid') ||
      (this.altSourcesDetails.newSolarSource !== undefined &&
        this.altSourcesDetails.newSolarSource.irradianceSensorLevel ===
          'BuildingLevel' &&
        (this.altSourcesDetails.newSolarSource.irradianceSensorBuilding ===
          'select' ||
          $('#sensorBuilding').hasClass('ng-invalid'))) ||
      $('#slrIOSrlNo').hasClass('ng-invalid') ||
      $('#slrName').hasClass('ng-invalid') ||
      $('#slrMake').hasClass('ng-invalid')
    ) {
      this.showErrorForNewSolar = true;
      return false;
    } else {
      return true;
    }
  }

  validNewSolarTempDetails() {
    if (
      $('#tempSensorFlowChannel').hasClass('ng-invalid') ||
      $('#tempSensorLevel').hasClass('ng-invalid') ||
      this.altSourcesDetails.newSolarTemp.temperatureSensorLevel ===
        'BuildingLevel' ||
      $('#tempSensorIOSrlNo').hasClass('ng-invalid') ||
      $('#tempSensorName').hasClass('ng-invalid')
    ) {
      this.showErrorForNewSolar = true;
      return false;
    } else {
      return true;
    }
  }

  generateIrradianceSensorsForm(noOfItems) {
    let model;
    this.altSourcesDetails.inlets = [];
    model = this.altSourcesDetails.inlets;
    for (let i = 0; i < noOfItems; i++) {
      model.push({ valveSwitchPresent: true });
    }
  }
  generateInvertersForm(noOfItems) {
    let model1;
    this.altSourcesDetails.inverterDetails = [];
    model1 = this.altSourcesDetails.inverterDetails;
    for (let i = 0; i < noOfItems; i++) {
      model1.push({ hasInverter: true });
    }
  }
  getSelectedValue() {
    const t = this;
    t.siteService
      .getInverterMakeOfSolarProcess(
        t.siteId,
        t.altSourcesForStringsAndModules.altsolarAreaNames.name
      )
      .subscribe((data) => {
        t.InverterMakeList = data;
      });
  }
  getStringsList() {
    const t = this;
    t.siteService
      .getStringDetails(
        t.altSourcesForStringsAndModules.altsolarAreaNames.name,
        t.altSourcesForStringsAndModules.invertersMake
      )
      .subscribe((data) => {
        t.StringNameList = data;
      });
  }
  generateStringsForm(noOfItems) {
    let model;
    this.altSourcesForStringsAndModules.altstringDetails = [];
    model = this.altSourcesForStringsAndModules.altstringDetails;
    for (let i = 0; i < noOfItems; i++) {
      model.push({ hasStrings: true });
    }
  }
  addString(event) {
    const t = this;
    t.siteService
      .saveStringsAndPvModules(t.siteId, t.altSourcesForStringsAndModules)
      .subscribe((data) => {
        t.getStringsList();
        t.alertService.showSuccess(Constants.MESSAGE.Save_success);
      });
  }
  generatepvModulesForm(noOfItems) {
    let model;
    this.altSourcesForStringsAndModules.altmoduleDetails = [];
    model = this.altSourcesForStringsAndModules.altmoduleDetails;
    for (let i = 0; i < noOfItems; i++) {
      model.push({ hasPVModule: true });
    }
  }
  addPVModule() {
    const t = this;
    t.siteService
      .savePvModules(t.siteId, t.altSourcesForStringsAndModules)
      .subscribe((data) => {
        t.alertService.showSuccess(Constants.MESSAGE.Save_success);
      });
  }
  public previousStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.GroupConfiguration, this.siteModel)
    );
  };
  nextStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.AlertsConfiguration, this.siteModel)
    );
  };
}
